import API from './API';
import { DELETE, GET, POST } from '../utils/Executer';
import { FAVORITES_SERVICE_URL as servicePath } from '../constants/APIconstants';

class FavoritesServiceAPI {
  async get() {
    return await API.client.execute(GET, `${servicePath}`);
  }

  async create({ itemId, entity, workspaceId }) {
    return await API.client.execute(POST, `${servicePath}?workspace=${workspaceId}`, {
      itemId,
      entity,
    });
  }

  async delete({ id }) {
    return await API.client.execute(DELETE, `${servicePath}${id}`);
  }
}

export default new FavoritesServiceAPI();
